let revealed = false;

function revealStartupFailure(): void {
  if (revealed) return;
  const root = document.getElementById('root');
  if (root === null || root.childElementCount > 0 || root.textContent?.trim()) return;
  revealed = true;
  const main = document.createElement('main');
  main.className = 'fatal-screen';
  main.setAttribute('role', 'alert');

  const mark = document.createElement('img');
  mark.src = '/crownweald-mark.svg';
  mark.alt = '';
  const title = document.createElement('h1');
  title.textContent = 'The gate could not open';
  const message = document.createElement('p');
  message.textContent = 'The client did not start correctly. Reload to request the latest safe build.';
  const reload = document.createElement('a');
  reload.className = 'primary-button';
  reload.href = location.href;
  reload.textContent = 'Reload Crownweald';
  main.append(mark, title, message, reload);
  root.replaceChildren(main);
}

addEventListener('error', revealStartupFailure);
addEventListener('unhandledrejection', revealStartupFailure);
setTimeout(revealStartupFailure, 10_000);
